import {
  GET_DOCUMENT_TYPES_SUCCESS,
  DOCUMENT_TYPE_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
  documentTypeList: [],
  error: {}
}

const documentType = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DOCUMENT_TYPES_SUCCESS:
      return {
        ...state,
        documentTypeList: action.payload,
      }
    case DOCUMENT_TYPE_API_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}

export default documentType